export const areasMixin = {
  computed: {
    stationsAlt() {
      let names = []
      if (this.stations.length > 0) {
        names = this.stations.map((b, idx) => Object.assign({ index: idx }, b))
      //   // console.log('POLICE STATIONS: ', this.stations)
      //   // console.log('POLICE STATIONS NAMES: ', names)
      //   // SAN JAVIER
      //   const SJA = names.find(item => item.name === 'EST San Javier A')
      //   const indexSJA = names.findIndex(item => item.name === 'EST San Javier A')
      //   const SJB = names.find(item => item.name === 'EST San Javier B')
      //   const indexSJB = names.findIndex(item => item.name === 'EST San Javier B')
      //   // SAN CRISTOBAL
      //   const SCA = names.find(item => item.name === 'SUB Corregimiento de San Cristóbal A')
      //   const indexSCA = names.findIndex(item => item.name === 'SUB Corregimiento de San Cristóbal A')
      //   const SCB = names.find(item => item.name === 'SUB Corregimiento de San Cristóbal B')
      //   const indexSCB = names.findIndex(item => item.name === 'SUB Corregimiento de San Cristóbal B')
      //   // SAN JAVIER
      //   const SJ = {
      //     name: 'EST San Javier',
      //     type: 'policeStation',
      //     geostring: [
      //       SJA.geostring,
      //       SJB.geostring
      //     ],
      //     id: [
      //       SJA.id,
      //       SJB.id
      //     ]
      //   }
      //   // SAN CRISTOBAL
      //   const SC = {
      //     name: 'SUB San Cristóbal',
      //     type: 'policeStation',
      //     geostring: [
      //       SCA.geostring,
      //       SCB.geostring
      //     ],
      //     id: [
      //       SCA.id,
      //       SCB.id
      //     ]
      //   }
      //   // SAN CRISTOBAL
      //   names.splice(indexSCB, 1)
      //   names.splice(indexSCA, 1, SC)
      //   // SAN JAVIER
      //   names.splice(indexSJB, 1)
      //   names.splice(indexSJA, 1, SJ)
      }
      // // console.log('NAMES POLICE STATIONS: ', names)
      return names
    },
    communesAlt() {
      let names = []
      if (this.communes.length > 0) {
        names = this.communes.map((b, idx) => Object.assign({ index: idx }, b))
        // console.log('COMMUNES: ', this.communes)
        // console.log('COMMUNES NAMES: ', names)
        // SAN JAVIER
        const SJA = names.find(item => item.name === 'San Javier A')
        const indexSJA = names.findIndex(item => item.name === 'San Javier A')
        const SJB = names.find(item => item.name === 'San Javier B')
        const indexSJB = names.findIndex(item => item.name === 'San Javier B')
        // SAN CRISTOBAL
        const SCA = names.find(item => item.name === 'San Cristóbal A')
        const indexSCA = names.findIndex(item => item.name === 'San Cristóbal A')
        const SCB = names.find(item => item.name === 'San Cristóbal B')
        const indexSCB = names.findIndex(item => item.name === 'San Cristóbal B')
        // console.log(SJA)
        // console.log(SJB)
        // SAN JAVIER
        const SJ = {
          name: 'San Javier',
          type: 'commune',
          geostring: [
            SJA.geostring,
            SJB.geostring
          ],
          id: [
            SJA.id,
            SJB.id
          ]
        }
        // SAN CRISTOBAL
        const SC = {
          name: 'San Cristóbal',
          type: 'commune',
          geostring: [
            SCA.geostring,
            SCB.geostring
          ],
          id: [
            SCA.id,
            SCB.id
          ]
        }
        // SAN JAVIER
        names.splice(indexSJB, 1)
        names.splice(indexSJA, 1, SJ)
        // SAN CRISTOBAL
        names.splice(indexSCB, 1)
        names.splice(indexSCA, 1, SC)
      }
      // console.log('NAMES COMMUNES: ', names)
      return names
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/areasMixin.js